import React, {Component} from 'react';

import {createGAEvent} from '@optimaxdev/analytics/desktop/lib/gaEvent/index';
import {pushDataLayer} from '@optimaxdev/analytics/desktop/lib/pushDataLayer/index';
import {Modal} from '@optimaxdev/design-system';
import {connect} from 'react-redux';

import {SUCCESS_PAGE_POPUP_CLOSED} from 'constants/analytics/events/successPage';
import {ApplicationStoreType} from 'desktop/store';
import {logWithSentry} from 'libs/sentry/sentry';
import {ActionCreatorType} from 'types/reducers';

import {setPopupLoading} from '../../store/reducers/orderLast/orderLast';
import {setUpsellTimer} from '../../store/reducers/upsellTimer/upsellTimer';
import {getTrustpilotQueryString} from '../../store/selectors/orderLast/orderLast';

import s from './trustPilot.scss';

export type PropsType = {
    setUpsellTimerAction: ActionCreatorType;
    setIsLoading: (isLoading: boolean) => void;
    trustpilotQueryString: string;
};
type StateType = {
    isPopupVisible: boolean;
};

/**
 * Trust Pilot layout for render popup
 */
export class TrustPilot extends Component<PropsType, StateType> {
    state = {
        isPopupVisible: true,
    };

    /**
     * Called after component was mounted for the first time
     */
    componentDidMount() {
        this.props.setIsLoading(true);
        if (!this.props.trustpilotQueryString) {
            logWithSentry(
                new Error('No "trustpilotQueryString" was provided to trustPilot iframe'),
            );
        }
    }

    /**
     * Close popup
     */
    closePopup = () => {
        this.setState({
            isPopupVisible: false,
        });

        this.props.setUpsellTimerAction();
        pushDataLayer(createGAEvent(SUCCESS_PAGE_POPUP_CLOSED));
        this.props.setIsLoading(false);
    };

    /**
     * On trust pilot frame load
     */
    onLoad = () => this.props.setIsLoading(false);

    /**
     * Render jsx to html
     * @returns {Node} Rendered react component
     */
    render() {
        const {trustpilotQueryString} = this.props;
        return (
            <Modal
                isOpen={this.state.isPopupVisible}
                onRequestClose={this.closePopup}
                overlay="dark"
            >
                <iframe
                    className={s.iframe}
                    height="900px"
                    marginHeight={0}
                    marginWidth={0}
                    name="trustpilot"
                    onLoad={this.onLoad}
                    src={`https://www.trustpilot.com/evaluate/embed/www.glassesusa.com${trustpilotQueryString}`}
                    title="trustpilot"
                    width="600px"
                    allowFullScreen
                />
            </Modal>
        );
    }
}
const mapDispatchToProps = {
    setIsLoading: setPopupLoading,
    setUpsellTimerAction: setUpsellTimer,
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
export const mapStateToProps = (store: ApplicationStoreType) => ({
    trustpilotQueryString: getTrustpilotQueryString(store),
});
export const TrustPilotConnected = connect(mapStateToProps, mapDispatchToProps)(TrustPilot);
